<style lang="scss">
@import "@/styles/main.scss";

.main-background-color {
  width: auto;
  height: auto;
  background-color: blue !important;
  overflow: auto;
  overflow-x: hidden;
}
</style>

<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
};
</script>
